var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"graph",staticClass:"force-directed-graph"},[_c('svg',{attrs:{"id":"svg","pointer-events":"all","viewBox":`0 0 ${_vm.graphWidth} ${_vm.graphHeight}`,"preserveAspectRatio":"xMinYMin meet"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }